<template>
  <div class="calendar-day-opened">
    <ol class="list-unstyled">
      <li v-for="(line, i) in list" :key="i">
        <a
          :href="
            line.cat === 'div'
              ? `/dashboard/` +
                line.tickername
                  .split(':')
                  .reverse()
                  .join('/')
              : line.link
          "
          @click.stop
          class="calendar-week-header calendar-day-of-week__title"
        >
          <strong>{{ line['CompanyName_' + $i18n.locale] }}</strong
          >{{ ' ' }}
          <template v-if="'div' !== line.cat">{{
            line['title_' + $i18n.locale]
          }}</template>
          <template v-else>{{
            $t('calendar.events.type.div', [dividendText(line)])
          }}</template>
        </a>
      </li>
    </ol>
  </div>
</template>

<script>
import { financial } from '@/utils/filters'
const DAY = 1000 * 60 * 60 * 24

const dividendText = (event) => {
  const profit = financial(
    ((event.dividend * event.currencyRatio) / event.basisDivPrice) * 100
  )
  let currency =
    {
      dollars: '$',
      euros: '€',
      pounds: '£',
      rubles: '₽',
    }[event.currency] || ''

  return `${currency}${event.dividend} (${profit}%)`
}
export { dividendText }

export default {
  props: {
    date: Date,
  },
  data() {
    return {
      loading: true,
      list: [],
    }
  },

  methods: {
    dividendText,
    loadDay(date) {
      this.loading = true
      this.$store
        .dispatch('request/getCalendarEvents', {
          selectedView: 'all',
          startDay: date,
          endDay: new Date(+date + DAY),
        })
        .then((res) => {
          this.list = res && res[0] && res[0].events
        })
        .catch((err) => {
          this.$store.dispatch('layout/showMessage', {
            title: 'Error',
            message: `Get events for day ${err}`,
            type: 'error',
          })
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss">
.calendar .calendar-day-opened {
  position: absolute;
  bottom: 0;
  width: calc(100% + 1.4rem);
  min-width: 140px;
  right: calc(-0.7rem);
  background: white;
  padding: 0 0.86666rem;

  border: #c2c2d6 0.06666rem solid;
  border-radius: 8px;

  :hover {
    cursor: pointer;
  }
}
</style>
